export enum SurveyResponseStatus {
    INCOMPLETE = 'incomplete',
    COMPLETED = 'completed',
}
